import {Box, Text} from '@mantine/core';
import type React from 'react';

export const PreviewModeTag: React.FC = () => {
  return (
    <Box className="flex flex-col">
      <Box className="rounded-[26px] items-center justify-center bg-notification px-16 py-[10px] w-[152px] h-[44px]">
        <Text className="text-white text-base text-center">
          プレビューモード
        </Text>
      </Box>
      <Box className="p-8">
        <Text className="text-notification">
          現在、プレビューモードで閲覧をしています。
          <br />
          該当ページの確認以外は利用できません。
        </Text>
      </Box>
    </Box>
  );
};
